import { useMemo } from 'react';
import { KnowledgeChatContext } from '../ChatContext';
import { KnowledgeChat } from '../KnowledgeChat';
import { useKnowledgeBuilder } from '../KnowledgeBuilderProvider';
import { useDefinitionInterview } from './DefinitionContext';

const INTERVIEW_PROMPTS = [
  "Let's define this System's purpose",
  'What is in scope, and what is out of scope?',
  'Which Systems or services does this integrate with?',
  'What availability target does this need to meet?',
];

// Reuses the real chatbot component (same markdown rendering, avatars,
// activity indicator, composer) by adapting the interview's state into the
// same KnowledgeChatContext contract the Dev Mode chat and the global
// assistant already use, instead of re-styling a second chat UI.
export const InterviewChatPane = () => {
  const { session, uploadFiles } = useKnowledgeBuilder();
  const {
    messages,
    isSending,
    sendInterviewMessage,
    abortInterviewMessage,
  } = useDefinitionInterview();

  const chatContextValue = useMemo(
    () => ({
      session,
      messages,
      isSending,
      sendMessage: (message: string) => sendInterviewMessage(message),
      abortMessage: abortInterviewMessage,
      uploadFiles,
    }),
    [session, messages, isSending, sendInterviewMessage, abortInterviewMessage, uploadFiles],
  );

  return (
    <div
      className="knowledge-builder-scrollbar"
      style={{
        width: 320,
        flex: '0 0 320px',
        display: 'flex',
        minHeight: 0,
      }}
    >
      <KnowledgeChatContext.Provider value={chatContextValue}>
        <KnowledgeChat suggestedPrompts={INTERVIEW_PROMPTS} />
      </KnowledgeChatContext.Provider>
    </div>
  );
};
